export const ROOM_UI_HIDE_QUERY_PARAM_NAME = "room:ui:hide";
